import { render, staticRenderFns } from "./VButtonGroup.vue?vue&type=template&id=54b8d68d&scoped=true&"
import script from "./VButtonGroup.vue?vue&type=script&lang=js&"
export * from "./VButtonGroup.vue?vue&type=script&lang=js&"
import style0 from "./VButtonGroup.vue?vue&type=style&index=0&id=54b8d68d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b8d68d",
  null
  
)

export default component.exports